// extracted by mini-css-extract-plugin
export default {"submitBlock":"BFilterNext-module_submitBlock_cd914edd","submitBlockCustom":"BFilterNext-module_submitBlockCustom_bf1ec60c","workspace":"BFilterNext-module_workspace_ddb287fc"};